// Desc: ClientDB page for admin
import React, { useState } from "react";
import { Tab } from "semantic-ui-react";

import { ClientDBList } from "../../../../components/Admin/ClientDB";

import "./ClientDB.scss";

export function ClientDB() {
  const [reload, setReload] = useState(false);

  const onReload = () => setReload((prevState) => !prevState);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ClientDBList reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="clientdb-page">
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>
    </>
  );
}
